<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content">
      <h2>新增会员</h2>
      <!-- <div class="line"></div> -->
      <div>
        <el-form
          :model="infoForm"
          :rules="rules"
          ref="ruleForm"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="会员名称" prop="name" style="margin-top: 20px">
            <el-input
              maxlength="10"
              v-model="infoForm.name"
              show-word-limit
              placeholder="请输入会员名称"
              style="width: 490px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="有效期"
            prop="expirationDate"
            style="margin-top: 20px"
          >
            <el-select v-model="infoForm.expirationDate">
              <el-option label="一个月" value="1"></el-option>
              <el-option label="三个月" value="3"></el-option>
              <el-option label="一年" value="12"></el-option>
              <el-option label="永久" value="0"></el-option>
            </el-select>
            <span style="margin-left: 20px; margin-right: 12px">购买价格</span>
            <el-input
              placeholder="请输入价格"
              size="mini"
              v-model="infoForm.price"
              oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
              style="width: 160px; position: relative"
            ></el-input>
            <span
              style="
                position: absolute;
                left: 496px;
                top: 2px;
                font-size: 14px;
                color: #cccccc;
              "
              >元</span
            >
          </el-form-item>
          <el-form-item
            label="会员介绍页"
            prop="introduce"
            style="margin-top: 20px"
          >
            <quill-editor
              v-model="infoForm.introduce"
              ref="myQuillEditor"
              :options="editorOption"
              class="editor"
            ></quill-editor>
            <div class="bottom" style="display: none">
              <el-upload
                class="centerImg"
                :action="' '"
                list-type="picture-card"
                :auto-upload="false"
                :on-change="handleAvatarChangeIcon"
                ref="uploadicon"
              >
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item
            label="会员状态"
            prop="status"
            style="margin-top: 20px; margin-bottom: 20px"
          >
            <el-radio v-model="infoForm.status" label="1">启用</el-radio>
            <el-radio v-model="infoForm.status" label="0">禁用</el-radio>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content bottom-but">
      <el-button type="warning" @click="toBack">返回</el-button>
      <el-button type="primary" @click="submitFn">确认</el-button>
      <div style="height: 20px"></div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
import { quillEditor } from 'vue-quill-editor'
import mixinsGoodsEditQuill from '../../goods/mixins/mixinsGoodsEditQuill.js'
import Quill from 'quill'
import imageResize from 'quill-image-resize-module' // 引用
import { ImageDrop } from 'quill-image-drop-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', imageResize) // 注册
export default {
  components: {
    breadcrumbTop,
    LbTable,
    quillEditor
  },
  mixins: [mixinsGoodsEditQuill],
  data () {
    return {
      dataList: {
        list: [
          { title: '矩阵管理', path: '', type: '0' },
          { title: '平台列表', path: '', type: '0' },
          { title: '新增会员', path: '', type: '1' }
        ]
      },
      infoForm: {
        name: '',
        platformId: null,
        expirationDate: '', //有效期,0是永久，1一个月，3三个月，12一年
        price: '',
        introduce: '',
        status: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入会员名称', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
        ],
        expirationDate: [
          { required: true, message: '请选择有效期', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'change' }
        ],
        introduce: [
          { required: true, message: '请输入介绍', trigger: 'change' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      vipId: null
    }
  },
  created () {
    this.infoForm.platformId = this.$route.query.id
    this.vipId = this.$route.query.vipId || null
    this.infoForm.id = this.vipId;
    if (this.vipId) {
      this.getInfo()
    }
  },

  mounted () {

  },
  methods: {
    getInfo () {
      this.axios.get('/ps/psMembers/info?id=' + this.vipId)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            Object.keys(this.infoForm).forEach(item => {
              this.infoForm[item] = res.data[item]
            })
            this.infoForm.status = this.infoForm.status + ''
            this.infoForm.expirationDate = this.infoForm.expirationDate + ''
          }
        })
    },
    toBack () {
      history.go(-1)
    },
    submitFn () {
      console.log('介绍', this.infoForm.introduce)
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.axios.post('/ps/psMembers/addEdit', this.infoForm)
            .then(res => {
              console.log(res)
              if (res.code == 0) {
                history.go(-1)
              }
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },


    add (type, id) {
      if (type == 'look') {
        this.$router.push({
          name: 'lookPlatform',
          query: {
            type: type,
            id: id
          }
        })
      } else {
        this.$router.push({
          name: 'newVip',
          query: {
            type: type,
            id: id
          }
        })
      }

    },
    setting () {
      this.$router.push({
        name: 'settingPlatform',
        query: {}
      })
    }
  }
}
</script>
<style  lang="scss">
.el-cascader-panel {
  .el-scrollbar:first-child {
    .el-checkbox {
      display: none;
    }
  }
}
</style>
<style scoped lang="scss">
.bottom-but {
  margin-top: -20px;
  //   text-align: center;

  .el-button {
    width: 220px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }

  .el-button + .el-button {
    margin-left: 32px;
  }
}

.line {
  width: 100%;
  height: 1px;
  background-color: #ededed;
  margin-top: 24px;
}

::v-deep .el-cascader-panel:first-child .el-checkbox {
  display: none !important;
}

::v-deep .el-cascader-panel li[aria-haspopup] .el-checkbox {
  display: none !important;
}

.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 5px;
}

.title {
  display: flex;
  justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 82px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 82px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>
  
  